<template>

  <div>

    <t-msg info>Recurso em desenvolvimento, por enquanto não exibido em nenhum relatório, previsão de término em 25/11/2024.</t-msg>

    <ChecklistContentDialog :command="command"
                            :foreign-key="foreignKey"
                            :primary-key="form.checklistContentId"
                            @onSubmit="onChecklistContentDialog"/>

    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth"
                 :status="status"
                 :path="path"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 primary-key-column="checklistContentId"
                 :primary-key="form.checklistContentId"
                 :foreign-key-column="foreignKeyColumn"
                 :foreign-key="foreignKey"
                 sortable
                 enable-change-order-up-down
                 disable-footer-length
                 @onChangeOrder="getList"
                 @onSubmit="onSubmit" @onItemRead="onContentReadItem" @onItemDelete="onItemDeleteDefault">

      <div class="ml-1 mb-3">

        <t-button @click="openContentInsert">
          <b-icon-plus-circle/>
          {{ t('insert') + ' Conteúdo' }}
        </t-button>

      </div>

      <t-input v-model="form.checklistContentId" hidden/>

      <template #item(typeContent)="{item}">

        <div v-if="item.typeContent === ContentType.type.BEFORE">Início</div>
        <div v-else>Fim</div>
      </template>

    </t-form-list>

  </div>

</template>

<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"
import ContentType from "@/model/types/resource/ContentType";
import ChecklistContentDialog from "@/views/modules/checklist/ChecklistContentDialog";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {tFormList, ChecklistContentDialog},
  name: 'ChecklistContent',
  data() {
    return {
      ContentType,
      path: "checklist/content", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "checklistId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "checklistContentId", keyDelete: "checklistContentId"},
        {key: "typeContent", label: "Tipo", cols: "1", formatter: ""},
        {key: "title", label: "Título", cols: "3"},
        {key: "content", label: "Conteúdo", cols: "3"},
        {key: "qtyPhotos", label: "Qtd. Fotos.", cols: "2", formatter: "number"},

      ],
      form: {
        checklistId: this.foreignKey,
        checklistContentId: 0,
        title: "",
        content: "",
        typeContent: ContentType.type.BEFORE,
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        checklistContentId: "",
      },
    }
  },
  computed: {
    onForm() {
      return this.form
    }
  },
  methods: {


    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()

    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {


      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.checklistContentId)


    },

    mountedList() {


      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    openContentInsert() {
      this.form.checklistContentId = 0
      this.command = 'insert'
      this.openDialogForm('modal-checklist-content-dialog')
    },
    onContentReadItem(id) {
      this.form.checklistContentId = id
      this.command = 'update'
      this.openDialogForm('modal-checklist-content-dialog')
    },

    async onChecklistContentDialog() {

      //Atualiza a listagem
      await this.getList()

    },
    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
